import { render, staticRenderFns } from "./AspectRatioSelector.vue?vue&type=template&id=a78980c6"
import script from "./AspectRatioSelector.vue?vue&type=script&lang=js"
export * from "./AspectRatioSelector.vue?vue&type=script&lang=js"
import style0 from "./AspectRatioSelector.vue?vue&type=style&index=0&id=a78980c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports